import Concrete from './concrete';
import {R, LIGHT_R, CENTER, INNER_R, FAN_RADIAN} from './dimension';
import {LANG} from '../LangConfig'
import {drawFans} from "./fan";
import src1 from './spin_mclaren.png'; // 128 × 141
import src2 from './spin_iphone.png'; // 112 x 148
import src3 from './spin_mercedes.png'; // 182 x 146
import src4 from './spin_cash50.png'; // 182 × 147
import src5 from './spin_gold.png'; // 182 x 151
import src6 from './spin_cash500.png';
import src7 from './spin_audi.png';
import src8 from './spin_cash30.png';
import src9 from './spin_hublot.png';
import src10 from './spin_cash100.png';
import src11 from './11.png';


export const imgPromises = Promise.all(
    [
        [src1, [205, 110], [80, 31]],
        [src2, [285, 145], [45, 56]],
        [src3, [280, 230], [84, 50]],
        [src4, [270, 300], [60, 40]],
        [src5, [200, 340], [80, 58]],
        [src6, [135, 345], [60, 40]],
        [src7, [60, 295], [80, 40]],
        [src8, [40, 233], [60, 40]],
        [src9, [55, 142], [83, 77]],
        [src10, [130, 105], [60, 40]],
        [src11, [130, 105], [60, 40]]

    ].map(
        ([src, ...dimension]) =>
            new Promise((res, rej) => {
                const img = new Image();
                img.src = src;
                img.onload = () => {
                    res([img, ...dimension]);
                };
            })
    )
);
export default (viewport,hover) => {
    let layer = new Concrete.Layer();
    viewport.add(layer);
    const scene = layer.scene;
    const ctx = scene.context;

    //Outer concentric circle
    ctx.beginPath();
    ctx.arc(CENTER[0], CENTER[1], R + LIGHT_R + 3, 0, 2 * Math.PI);
    ctx.fillStyle = '#17A5DC';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(CENTER[0], CENTER[1], R - LIGHT_R - 10, 0, 2 * Math.PI);
    //ctx.fillStyle = '#eff0ff';
    //ctx.fill();
    const cx = CENTER[0],
        cy = CENTER[1];
    imgPromises.then((array) => {
        const newArray = [...array];
        newArray.pop();
        const v = newArray
        const colors = ['#FFFFFF', '#EEEEEE', '#FFFFFF', '#EEEEEE', '#FFFFFF', '#EEEEEE', '#FFFFFF', '#EEEEEE', '#FFFFFF', '#EEEEEE'];
        drawFans(ctx, colors, v, cx, cy);

        //Bigger circle
        ctx.beginPath();
        const innerR=hover?30:INNER_R;
        ctx.arc(CENTER[0], CENTER[1], innerR, 0, 2 * Math.PI);
        ctx.fillStyle = 'white';
        ctx.shadowColor = '#d3d3d3';
        ctx.shadowBlur = 30;
        ctx.fill();

        //Inner circle
        ctx.beginPath();
        ctx.arc(CENTER[0], CENTER[1], innerR - 3, 0, 2 * Math.PI);
        ctx.fillStyle = '#034EA2';
        ctx.fill();


        ctx.shadowBlur = 0;
        ctx.fillStyle = 'white';
        ctx.textAlign = 'center';
        LANG==='zh'? ctx.font = '16px Microsoft YaHei':ctx.font = '16px Arial';
        const spin= LANG==='zh'?'抽奖':'Spin';

        ctx.fillText(spin, cx, cy + 5);

        viewport.render();
    });
};
